import '../../modules/mode-components';

import * as angular from 'angular';

import controller from './email-an-admin-controller';
import template from './interstitial-email-an-admin.html';

const interstitialEmailAnAdmin = function () {
  return {
    restrict: 'E',
    template: template,
    controller: controller,
    controllerAs: 'ctrl',
    scope: {},
  };
};

interstitialEmailAnAdmin.$inject = ['ModalService'];

angular.module('mode.components').directive('interstitialEmailAnAdmin', interstitialEmailAnAdmin);
